var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group",class:_vm.classCol},[_c('label',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.labelText))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }